//@ts-check
import { useDropzone } from "vue3-dropzone";
import attrAccept from 'attr-accept';
function generateUUID() { // Public Domain/MIT
	var d = new Date().getTime();//Timestamp
	var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16;//random number between 0 and 16
		if (d > 0) {//Use timestamp until depleted
			r = (d + r) % 16 | 0;
			d = Math.floor(d / 16);
		} else {//Use microseconds since page-load if supported
			r = (d2 + r) % 16 | 0;
			d2 = Math.floor(d2 / 16);
		}
		return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	});
}

/*
	<dropezone-vue class="form-group row"  original="attachment/temp/original.jpg"  @modifie="img" ></dropezone-vue>

	original = url de l'image originale
	@modifie = 	méthode déclenchée dès qu'une nouvelle image est uploadée
				Le paramètre envoyé est le nom de l'image dans le dossier temp du serveur.
				C'est la méthode save du document qui devra resizer l'image et la copier dans le dossier attachment du serveur.



	Si il y a une image existante, on l'affiche

	
	Au drop d'une image, le composant
	- crée un nom d'image temporaire drozonevue_xxxxxxxxxxxx,  xxxxxxxxxx étant un numéro unique.
	- poste l'image dans volume/temp/
	- Eventuellement, le serveur construit un thumbnail ${name}_T.jpg
	- Le composant affiche le thumbnail
	- Le composant  déclenche l'évènement modifie(nom d'image temporaire);
	
	Le serveur au moment de la sauvegarde du document devra 
		pour chaque image, faire une copie ou un gm/resize du dossier temp vers le dossier volume/attachment/linelist/{$id}_img_principale;
		save mongo du document en enregistrant le nom de l'image
*/
// 
const dropzoneVue = {
	props: {
		preview: String,
		original: String,	// url originale de l'image
		memo: String,		// message d'aide
		index: Number // index de l'element en cours dans la boucle
	},
	emits: ["modifie"], 	// quand une image est modifiée, envoie le nom de l'image.
	data() {
		const thisVue = this;
		//
		async function onDrop(acceptFiles, rejectReasons) {
			//
			//console.log("rejectReasons",rejectReasons)
			if (acceptFiles && acceptFiles.length) {
				thisVue.wait = true;
				thisVue.messageErreur = "";
				thisVue.messageOk = "";
				//
				//
				//
				try {
					const acceptFile = acceptFiles[0];
					//...
					let formData = new FormData();
					formData.append('file_to_upload', acceptFile);  // Here fileField is the input file reference
					if (thisVue.preview == 'img') {
						//console.log("thisVue.preview", thisVue.preview)
						formData.append('thumbnailWidth', 'tac');
					}
					formData.append('path', acceptFile.path);
					//
					const tempName = "drozonevue_" + generateUUID();
					const url = "dropzone/temp/" + tempName;
					const settings = {
						method: 'POST',
						headers: { Accept: 'application/json' },
						body: formData
					};
					const fetchResponse = await fetch(url, settings);
					//
					if (fetchResponse.status === 200) {
						let donnee = await fetchResponse.json();
						//
						if (thisVue.preview == 'img') {
							thisVue.img.src = (donnee.thumb) ? "attachment/temp/" + donnee.thumb + "?timestamp=" + Date.now() : "";
						}

						if (thisVue.preview == 'video') {
							thisVue.img.src = "assets/img/movie.png"
						}

						if (thisVue.preview == 'xlsx') {
							thisVue.img.src = "assets/img/excel.jpg"
						}

						thisVue.messageOk = "Ok";
						//
						thisVue.$emit('modifie', tempName, thisVue.index);
						//
					} else {
						let donnee = await fetchResponse.json();
						thisVue.messageErreur = "Invalid image format";
					}
				} catch (e) {
					thisVue.messageErreur = e.message || e
				}
				thisVue.wait = false;
			}
			//
			//
		}
		let accept = '';
		if (thisVue.preview  == 'img') accept = 'image/*';
		if (thisVue.preview  == 'video') accept = 'video/*';
		if (thisVue.preview  == 'xlsx') accept = '.xlsx';
		//const accept = 'image/*';//'video/*'; //attrAccept({ name: 'my file.json', type: 'application/json' }, 'image/*');
		//, accept: accept
		const { getRootProps, getInputProps, ...rest } = useDropzone({ onDrop, multiple: false, accept });

		return {
			copieOriginal : this.original || null,
			img: {
				src: this.original || null,
			},
			wait: false,
			dropGeneralPicture: {
				getRootProps,
				getInputProps,
				...rest,
			},
			messageOk: "",
			messageErreur: "",
		}
	},
	beforeUpdate: function () {

	},

	methods: {
		cancelImg() {
			this.messageOk = false;
			this.img.src = this.copieOriginal;
			this.$emit('modifie', "", true);
		},
	},
	template: `
		<div class="col col-sm-2"  >
			<div v-if="wait" class="d-flex justify-content-center">
				<div class="spinner-border" role="status">
				<span class="visually-hidden">Loading...</span>
				</div>
			</div>
			<img v-else :src=img.src class="img-fluid">
			<div class="text-center">
				<button class="btn btn-white btn-sm" v-if="messageOk" @click="cancelImg" > 
					Cancel
				</button>
			</div>
		</div>
		<div class="col text-center col-sm-10">
						<!-- {{preview}}  {{copieOriginal}} -->
			<div style="border: dashed 1px #95AAC9;border-radius: 10px" type="button" class="h-100 py-5" v-bind="dropGeneralPicture.getRootProps()">
				<input v-bind="dropGeneralPicture.getInputProps()" />
				<span v-if="dropGeneralPicture.isDragActive">Drop the file to upload</span>
				<span class="align-middle" v-else :class="messageErreur?'text-danger':''">
					<div v-show="messageErreur">
						{{messageErreur}}
					</div>
					<div>
						Drop file here, or click to select file to upload
					</div>
				</span>
			</div>
			<i>{{memo}}</i>
		</div>
	<slot></slot>
 `
}
// style="height:100px; border:dashed black 1px; margin:20px"

export { dropzoneVue };